<template>
    <div class="program-alarm" @click.prevent="clickAlarm">
      <alarm-on v-if="isOn"></alarm-on>
      <alarm-off v-else></alarm-off>
    </div>
</template>

<script>
import AlarmOn from '@/assets/svg/common/ic-detail-alart-on.svg'
import AlarmOff from '@/assets/svg/common/ic-detail-alart-off.svg'
import utils from '@/common/util/utils'
import { get } from 'lodash'
import { commonErrorProcess, LiveInfoService } from '@/common/api/api.service'
export default {
  name: 'AlarmButton',
  components: {
    AlarmOn,
    AlarmOff
  },
  props: {
    contentInfo: {
      type: Object
    }
  },
  data () {
    return {
      isOn: false
    }
  },
  methods: {
    async clickAlarm () {
      if (utils.cookies.getCredential() === 'none') {
        this.$router.replace(`/login?referer=${this.$route.fullPath.replace(location.origin, '')}`)
        return
      }
      let epgInfo = get(this.contentInfo, ['liveepgschannellist', 'list', '0'], null)
      // Info: live정보 들어올때랑, 편성표 epg 들어올때랑
      epgInfo = epgInfo === null ? this.contentInfo : epgInfo
      let contentid = this.contentInfo.channelid
      let programid = epgInfo.programid
      let releasedatetime = epgInfo.starttime
      let alarmtype = 'live'
      if (this.isOn) {
        if (await utils.asyncConfirm('시청 예약을 취소하겠어요?')) {
          LiveInfoService.deleteAlarms({ alarmtype, contentid, releasedatetime }).then(() => {
            this.$nextTick(() => {
              this.isOn = false
            })
            this.$toast({ message: '시청 예약이 취소되었어요.' })
          })
        }
      } else {
        LiveInfoService.getAlarms({ alarmtype, contentid, programid, releasedatetime }, (error) => {
          commonErrorProcess(error)
          throw new Error('error')
        }).then((res) => {
          this.$toast({ message: '시청 예약이 설정되었습니다.' })
          this.$nextTick(() => {
            this.isOn = true
          })
        }).catch(() => {
          this.isOn = false
        })
      }
    }
  },
  created () {
    this.isOn = get(this.contentInfo, ['liveepgschannellist', 'list', '0', 'alarm'], 'n') === 'y' ||
      get(this.contentInfo, 'alarm', 'n') === 'y'
  }
}
</script>
